import { store } from '../../redux'

const getCompanyHost = () => {
  const host = window.location.hostname.split('.')[0]

  if (host.includes('op')) return 'OP'

  return 'TA'
}

const COMPANY_HOST = getCompanyHost()

/**
 * Set headers for each request
 * @param {boolean} authToken used if the request needs an auth token
 * @param {boolean} defaultContentType Content-Type is empty
 * @return {Object}
 */
export default (authToken = false, defaultContentType = false) => {
  const headers = {
    'nx-company-host': COMPANY_HOST,
  }

  if (!defaultContentType) headers['Content-Type'] = 'application/json'

  if (authToken) {
    const token = store.getState().nxAuthToken.token
    headers['nx-auth-token'] = token
  }

  return headers
}
